"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hookrouter_1 = require("hookrouter");
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const ImportUnknown = ({ correlationId }) => {
    return (react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontalAlign: "center", verticalAlign: "center", verticalFill: true, tokens: { childrenGap: 15 }, styles: { root: { height: '400px' } } },
        react_1.default.createElement(office_ui_fabric_react_1.FontIcon, { iconName: "Clock", style: { fontSize: 50, color: '#ccc' } }),
        react_1.default.createElement(office_ui_fabric_react_1.Text, { block: true, variant: "large" }, "Import Pending!"),
        react_1.default.createElement(office_ui_fabric_react_1.Text, { block: true, variant: "small" }, "You should receive an email report soon. If this doesn't arrive with 15 mins please check the logs."),
        react_1.default.createElement(office_ui_fabric_react_1.Stack.Item, { styles: { root: { marginTop: '25px !important' } } },
            react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { styles: styles_1.styles.submitButton, text: "View Logs", onClick: () => hookrouter_1.navigate('/logs' + (correlationId ? '/' + correlationId : '')) }))));
};
exports.default = ImportUnknown;
